import apiClient from '../../utils/backend'

export const startLogin = (email, password) => {
  return async (dispatch) => {
    const res = await apiClient.post('api/login', { email, password })
    console.log(res)
    if (res.data.data.token !== undefined) {
      let d = res.data.data
      localStorage.setItem('lgt', d.token)
      localStorage.setItem('user_id', d.id)
      localStorage.setItem('profile', d.profile_id)
      localStorage.setItem('type_user', d.type?.id)
      localStorage.setItem('country_id', d.country_id)
      let user = {
        dentistId: d.dentist?.id,
        id: d.id,
        token: d.token,
        email: d.email,
        gender: d.gender,
        name: d.name,
        surname: d.surname,
        profile: d.profile_id,
        country: d.country_id,
        birthdate: d.birthdate,
        smilecreator: d.dentist?.smile_creator_type,
        smilecreator_points: d.dentist?.smile_creator_points,
        typeId: d.type.id,
      }
      dispatch(login(user))
      handleRedirect(d.type?.id)
      // cb(true)
    } else {
      console.log(res, 'con error')
    }
  }
}

const login = (user) => ({ type: 'LOGIN', payload: user })

const handleRedirect = (type) => {
  //this.props.history.push('/')
  if (type === 1) {
    window.location.href = '/ingresos'
  } else {
    window.location.href = '/od/home'
  }
}
